export default "__VITE_ASSET__DYl2uG4S__";